import ToolCard from './ToolCard'
import { tools } from '../data/tools'

interface RelatedToolsProps {
  toolIds: string[]
}

const RelatedTools: React.FC<RelatedToolsProps> = ({ toolIds }) => {
  const relatedTools = toolIds
    .map(id => tools.find(tool => tool.id === id))
    .filter((tool): tool is NonNullable<typeof tool> => Boolean(tool))
    .filter(tool => tool.status !== 'external')

  if (!relatedTools.length) return null

  return (
    <section className="mx-auto mt-8 max-w-4xl">
      <h2 className="mb-3 text-lg font-semibold text-slate-950">相关工具</h2>
      <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
        {relatedTools.map(tool => (
          <ToolCard key={tool.id} tool={tool} />
        ))}
      </div>
    </section>
  )
}

export default RelatedTools
